'use client';

import { PaletteProvider } from '@ensite/ui/lib/palette';
import { ThemeType } from '@ensite/ui/lib/palette';

export default function RootStaticLayout({ children }: { children: JSX.Element }) {
  return <PaletteProvider type={ThemeType.Page}>{children}</PaletteProvider>;
}
